<template>
  <div class="form_add_page" v-loading="isLoading">
    <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        {{ $route.query.operate }}
      </div>
      <zip-btn
        :name="claimantInfo.claimStatementNum"
        v-show="
          fileList &&
            fileList.length > 0 &&
            $route.query.operate != '责任确定'
        "
        :fileList="fileList"
      />
      <div
        v-if="$route.query.operate === '责任确定'"
        class="button_list flex-right"
      >
        <zip-btn
          :name="claimantInfo.claimStatementNum"
          v-show="fileList && fileList.length > 0"
          :fileList="fileList"
        />
        <el-button size="mini" type="primary" @click="handleHistory" style="margin-right:10px;">历史索赔记录</el-button>
        <el-button size="mini" type="success" @click="handleExamine(1)"
          >同意</el-button
        >
        <el-button size="mini" type="danger" @click="handleExamine(2)"
          >驳回</el-button
        >
        <el-button size="mini" type="primary" @click="back">返回列表</el-button>
        <el-button
          v-if="$route.query.enableNext === '1'"
          :loading="completeBtn"
          size="mini"
          type="primary"
          @click="getNextData('noExamine')"
          >下一条</el-button
        >
      </div>
    </div>
    <detail
      v-if="formLoading"
      ref="detailRef"
      :claimantInfo.sync="claimantInfo"
      :fieldsData="fieldsData"
      :previewFile="previewList"
    />
    <!-- 驳回弹窗 -->
    <el-dialog :title="examineName" width="550px" :visible.sync="showExamine">
      <el-form
        ref="examineForm"
        :model="examineForm"
        :rules="examineRules"
        label-width="130px"
      >
        <el-form-item
          v-if="examineName != '不同意'"
          :label="'请选择' + examineName + '原因'"
          prop="reason"

        >
          <el-select v-model="examineForm.reason" filterable clearable>
            <el-option
              v-for="(item, index) in reasonList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="examineForm.reason === '其他'"
          :label="'请填写' + examineName + '原因'"
          prop="remark"
          style="width:100%"
        >
          <el-input
            type="textarea"
            v-model="examineForm.remark"
            maxlength="1000"
            show-word-limit
            style="width:100%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="lang-but" type="primary" @click="confirmExamine">确定</el-button>
        <el-button class="lang-but" type="primary" plain @click="showExamine = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 审核完成弹窗 -->
    <el-dialog
      :visible.sync="showComplete"
      width="420px"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      center
    >
      <div style="text-align: center; width: 100%">
        <i
          class="el-icon-warning-outline"
          style="color: #E99D42; margin-right: 13px"
        />{{ completeTip }}
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button
          v-if="$route.query.enableNext === '1'"
          :loading="completeBtn"
          type="primary"
          size="mini"
          @click="getNextData"
          >下一条</el-button
        > -->
        <el-button
          :loading="completeBtn"
          type="primary"
          size="mini"
          @click="back"
          >返回列表</el-button
        >
      </span>
    </el-dialog>
<!--    查看历史索赔弹窗-->
    <el-dialog :close-on-click-modal="false" width="80%" title="历史记录" :visible.sync="historyDialog">
      <historyList  ref="historyRef" :vin="claimantInfo.vin" :claimantNum="claimantInfo.claimStatementNum" />
    </el-dialog>
  </div>
</template>

<script>
import {
  kdconfirmResponsibility,
  kdconfirmList,
  kdgetClimantDetail1
} from "@/api/seek";
import { setStorage } from "@/util/localStor";
import { getDictItem } from "@/util/dict";
import Detail from "./components/detail.vue";
import zipBtn from "@/components/downloadZip";
import historyList from "@/views/kd-claimant/components/historyList.vue";
export default {
  components: {historyList, Detail, zipBtn },
  data() {
    return {
      previewList:[],
      fileList:[],
      historyDialog:false,
      examineName: "", // 审核弹窗名称
      showExamine: false, // 审核弹窗
      showComplete: false, // 审核完成弹窗
      completeTip: "", // 审核完成提示
      completeBtn: false, // 审核完成弹窗按钮状态
      isLoading: false, // 页面加载状态
      claimantInfo: {}, // 表单数据
      formLoading: false,
      reasonList: [], // 审核原因下拉列表
      examineForm: {}, // 审核表单数据
      examineRules: {
        reason: [{ required: true, message: " " }],
        remark: [{ required: true, message: " " }]
      }, // 审核表单验证规则
      fieldsData: {

      }
    };
  },
  async mounted() {
    if (this.$route.query?.claimantId) {
      this.isLoading = true;
      const res = await kdgetClimantDetail1(this.$route.query?.claimantId);
      if (res.status == 0) {
        this.claimantInfo = res.data || {};
        this.fileList = this.claimantInfo.faultPartsList?.reduce((acc, item) => {
            if (item.fileList && item.fileList.length > 0) {
              acc.push(...item.fileList);
            }
          return acc;
        }, []);
        this.previewList = this.fileList?.filter(item => {
          return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
        });
        // 把每个不同零件的责任方取出来
        let responsibilityPartListArr=[]
        res.data.faultPartsList.map(v=>{
          v.responsibilityPartList.map(j=>{
            responsibilityPartListArr.push(j)
          })
        })
        this.claimantInfo.oldResponsibilityList = JSON.stringify(
          responsibilityPartListArr
        );
      } else {
        this.$DonMessage.error(res.message);
      }
      this.isLoading = false;
    }
    this.$nextTick(() => {
      this.formLoading = true;
    });
    // 获取驳回原因
    this.reasonList = await getDictItem("rejectCause");
  },
  methods: {
    // 打开历史详情记录
    handleHistory(){
      this.historyDialog = true
      this.$nextTick(() => {
        this.$refs.historyRef.initData()
      })
    },
    // 获取详情数据
    async getDetailData() {

      this.isLoading = true;
      const res = await kdgetClimantDetail1(this.$route.query?.claimantId);
      if (res.status == 0) {
        this.claimantInfo = res.data || {};
        this.fileList = this.claimantInfo.faultPartsList?.reduce((acc, item) => {
            if (item.fileList && item.fileList.length > 0) {
              acc.push(...item.fileList);
            }
          return acc;
        }, []);
        this.previewList = this.fileList?.filter(item => {
          return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
        });
        // 把每个不同零件的责任方取出来
        let responsibilityPartListArr=[]
        res.data.faultPartsList.map(v=>{
          v.responsibilityPartList.map(j=>{
            responsibilityPartListArr.push(j)
          })
        })
        this.claimantInfo.oldResponsibilityList = JSON.stringify(
          responsibilityPartListArr
        );
        this.$nextTick(() => {
          this.formLoading = true;
        });
        // 获取驳回原因
        this.reasonList = await getDictItem("rejectCause");
      } else {
        this.$DonMessage.error(res.message);
      }
      this.isLoading = false;
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 审核
    async audit(status, remark) {
      this.$refs.detailRef.$refs.form.validate(async valid => {
        // 正审时校验必填项
        if ( !valid && this.examineName !== '驳回' && this.examineName !== '拒赔' ) {
          this.$notify.error({
            message: "信息填写完整再提交",
            offset: 100,
            duration: 2000
          });
          return;
        }else {
          
          let arr = this.$refs.detailRef.getZerenList()
          if(arr && arr.length>0){
            arr.forEach((m,i)=>{
              this.claimantInfo.faultPartsList?.map(item=>{
                if(m.faultPartId == item.faultPartId){
                    m.faultPartId = item.faultPartId
                    m.claimStatementId = item.claimStatementId
                    m.faultPartName = item.faultPartName
                    m.faultPartNameZh = item.faultPartNameZh
                    m.faultPartNumber = item.faultPartNumber
                }
              })
            })
          }
          // // 把每个不同零件的责任方取出来
          // let responsibilityPartListArr=[]
          // arr?.map(v=>{
          //   if (v.responsibilityPartList&&
          //     v.responsibilityPartList.length > 0){
          //     v.responsibilityPartList.map(j=>{
          //       j.faultPartId = v.faultPartId
          //       responsibilityPartListArr.push(j)
          //     })
          //   }

          // })
          let canSubmit = true
          if(this.examineName !== '驳回'  && this.examineName !== '拒赔'){
            arr?.map((item,i)=>{
            if(item.faultPartId ==''){
              this.$DonMessage.warning('请选择责任方故障件件号后再提交')
              canSubmit = false
            }
            })
          }else{
            
            var filteredArray  = []
            filteredArray = arr?.filter(item => item.faultPartNumber !== "");
          }
          const submitData = {
            claimStatementId: this.claimantInfo.claimStatementId,
            kdClaimFaultyPartsEntityListzeren: (this.examineName == '驳回'||this.examineName == '拒赔')?filteredArray:arr,
            newResponsibilityList: (this.examineName == '驳回'||this.examineName == '拒赔')?JSON.stringify(filteredArray):JSON.stringify(
              arr
            ),
            oldResponsibilityList: this.claimantInfo.oldResponsibilityList,
            status: status,
            remark: remark
          };
          if(canSubmit){
            this.isLoading = true;
            try {
            var res = await kdconfirmResponsibility({ data: submitData });
            if (res.status == 0) {
              this.isLoading = false;
              this.completeTip = `索赔订单 ${this.claimantInfo.claimStatementId} 已${this.examineName}`;
              this.showComplete = true;
            } else {
              this.isLoading = false;
              this.$DonMessage.error(res.message);
            }
          } catch (error) {
            this.isLoading = false;
          }
          }

        }





      });
    },
    // 点击审核
    async handleExamine(type) {
      if (type == 1) {
        this.examineName = "责任确定";
        this.$refs.detailRef.pageIndex = 'detail'
        if(this.$refs.detailRef.pageIndex=='detail'){
          this.$nextTick(() => {
            this.audit(11);
        });
        }
      }
      if (type == 2) {
        this.examineName = "驳回";
        this.showExamine = true;
        this.examineForm = {};
        this.$nextTick(() => {
          this.$refs.examineForm.clearValidate();
        });
      }
    },
    // 下一条
    async getNextData(type) {
      this.completeBtn = true;
      var query = JSON.parse(this.$route.query?.searchObj);
      if (type === "noExamine") {
        this.isLoading = true;
        query.page.pageNum = query.page.pageNum + 1;
      }

      const res = await kdconfirmList(query);
      if (res.status == 0) {
        this.completeBtn = false;
        this.isLoading = false;
        this.showComplete = false;
        if (res.data.records[0]) {
          setStorage("claimantData", res.data.records[0]);
          this.$router.replace({
            path: "/kd-claimant/claimResponsibilityConfirmDetail",
            query: {
              claimantId: res.data.records[0].claimStatementId,
              searchObj: JSON.stringify(query),
              enableNext: this.$route.query?.enableNext,
              operate: this.$route.query?.operate
            }
          });
          this.getDetailData();
        } else {
          this.$DonMessage.warning("筛选索赔单已审核完！")
        }
      } else {
        this.completeBtn = false;
        this.isLoading = false;
        this.$DonMessage.error(res.message);
      }
    },
    // 确认驳回
    confirmExamine() {
      this.$refs.examineForm.validate(async valid => {
        if (!valid) {
          return;
        }
        const submitData =
          this.examineForm.reason === "其他"
            ? this.examineForm.remark
            : this.examineForm.reason;
        this.showExamine = false;
        if (this.examineName == "驳回") {

          this.$refs.detailRef.pageIndex = 'detail'
          if(this.$refs.detailRef.pageIndex=='detail'){
            this.$nextTick(() => {
              this.audit(21, submitData);
          });
          }
          }
      });
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.form_add_page {
  // margin-top: 15px;
  padding-bottom: 20px;
  .form_info {
    ::v-deep .el-input {
      // width: 250px;
    }
  }
  ::v-deep .el-table__body .el-input {
    width: unset;
  }
  ::v-deep .el-textarea__inner {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
      "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
  .top-container {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: #fff;
    padding: 15px 32px 15px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .status-container {
    display: flex;
    align-items: baseline;
    padding: 13px 44px;
    border-bottom: 1px solid #dcdee0;
    .status {
      margin: 0 85px;
    }
    .btn {
      color: #4084ff;
      padding: 0;
      font-size: 16px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title-icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }

  .second-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .tips {
    line-height: 20px;
    color: #cecece;
    font-size: 14px;
    // p {
    //   font-size: 14px;
    //   line-height: 20px;
    // }
    // span {
    //   font-size: 12px;
    //   line-height: 16px;
    // }
  }
  .table-container {
    .is-error {
      ::v-deep .el-input__inner {
        border-color: #f56c6c;
      }
    }
    .table-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .text-btn {
        cursor: pointer;
        color: #4084ff;
        padding: 0;
        font-size: 14px;
      }
    }
  }
  .number-input {
    ::v-deep .el-input__inner {
      text-align: left;
    }
  }
  .is-error {
    color: #f56c6c;
    font-size: 12px;
  }
  .fanyi-box {
    // padding-left: 50px;
    ::v-deep .el-textarea__inner {
      height: 100px;
    }
    .textAreaTipBtn {
      cursor: pointer;
      width: fit-content;
      color: #1890ff;
    }
  }
}
.file {
  .file-list {
    margin: 0 10px;
    padding: 0 5px;
    box-sizing: border-box;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;
    display: flex;
    i {
      font-size: 20px;
    }
    span {
      display: inline-block;
      font-size: 12px;
      margin-left: 5px;
    }
    .right {
      font-size: 12px;
      padding: 0 5px;
      border: 1px solid #4095e5;
      text-align: center;
      margin-left: 30px;
      border-radius: 6px;
      height: 26px;
      line-height: 26px;
      box-sizing: border-box;
      opacity: 0;
    }
  }
  .file-list:hover {
    background: rgb(243, 246, 249);
    color: #4095e5;
    .right {
      opacity: 1;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 400px;
}
</style>
